var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.link)?_c('v-card',{staticStyle:{},attrs:{"oncontextmenu":"return false;"}},[_c('video',{key:_vm.key,ref:"videoPlayer",staticClass:"video-js vjs-fluid vjs-big-play-centered"})]):_c('p',{staticClass:"mx-2 my-2"},[_vm._v("Invalid Video Link")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }